<template>
  <DispatchInputWrapper :saving="project.data.projectNameSaving" :saved="project.data.projectNameSaved" :error="project.data.projectNameError">
    <template #default>
      <span class="p-float-label">
        <InputText id="projectName" type="text" v-model="project.data.projectNameInput" @blur="project.renameProject" />
        <label for="projectName">{{ t('autocbm.projects.form.label.name') }}</label>
      </span>
    </template>
  </DispatchInputWrapper>
</template>

<script>
import { reactive, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useDispatcher } from '@/dockone/components/dispatcher'

export default {
  name: 'ProjectDetails',
  setup () {
    const store = useStore()
    const { t } = useI18n()
    const { dispatches, handleDispatch, handleUpdate } = useDispatcher(['projectName'])

    const projectData = reactive({
      projectNameInput: null,
      projectName: computed(() => store.getters['autocbm/project/projectName']),
      projectNameDispatch: computed(() => dispatches.get('projectName')),
      projectNameSaving: computed(() => projectData.projectNameDispatch.pending > 0),
      projectNameSaved: computed(() => !!projectData.projectName && projectData.projectNameDispatch.success),
      projectNameError: computed(() => projectData.projectNameDispatch.error)
    })
    const projectActions = {
      renameProject () {
        if (projectData.projectName !== projectData.projectNameInput) {
          handleDispatch('projectName', store.dispatch('autocbm/project/rename', projectData.projectNameInput))
        }
      }
    }
    const project = { data: projectData, ...projectActions }

    watch(() => project.data.projectName, projectName => {
      handleUpdate('projectName', projectName)
      project.data.projectNameInput = projectName
    }, { immediate: true })

    return { t, project }
  }
}
</script>
